import { defineComponent, ref, inject, computed, watch, onUpdated } from '@vue/composition-api';
import { SdsAccordionContext } from './symbols.js';
import __vue_component__ from '../SdsIcon/SdsIcon.vue.js';
import __vue_component__$1 from '../SdsDividerLine/SdsDividerLine.vue.js';

var script = defineComponent({
    props: {
        title: {
            type: String,
            required: false,
            default: undefined,
        },
        hasDividerLine: {
            type: Boolean,
            required: false,
            default: true,
        },
        isDisabled: {
            type: Boolean,
            default: false,
        },
        isPreOpened: {
            type: Boolean,
            default: false,
        },
    },
    emits: [
        'open',
        'close',
    ],
    setup: function (props, _a) {
        var _b;
        var slots = _a.slots, emit = _a.emit;
        var contentBoxRef = ref(null);
        var accordionContext = inject(SdsAccordionContext);
        var uuid = ref(accordionContext === null || accordionContext === void 0 ? void 0 : accordionContext.getUuid());
        var isOpen = ref(props.isPreOpened || ((_b = accordionContext === null || accordionContext === void 0 ? void 0 : accordionContext.active) === null || _b === void 0 ? void 0 : _b.value) && (accordionContext === null || accordionContext === void 0 ? void 0 : accordionContext.active.value.index) === uuid.value);
        var hasRowIconSlot = computed(function () { return !!slots['rowIcon']; });
        var handleClick = function () {
            if (props.isDisabled) {
                return;
            }
            accordionContext === null || accordionContext === void 0 ? void 0 : accordionContext.setActive({
                index: uuid.value,
                height: 0,
            });
        };
        watch(function () { return accordionContext === null || accordionContext === void 0 ? void 0 : accordionContext.active.value; }, function (newActive) {
            isOpen.value = newActive && newActive.index === uuid.value;
        });
        watch(function () { return !!(isOpen.value); }, function (newValue) {
            if (newValue) {
                emit('open');
            }
            else {
                emit('close');
            }
        });
        onUpdated(function () {
            var _a;
            if (isOpen.value) {
                accordionContext === null || accordionContext === void 0 ? void 0 : accordionContext.setActiveHeight(((_a = contentBoxRef.value) === null || _a === void 0 ? void 0 : _a.clientHeight) || 0);
            }
        });
        return {
            contentBoxRef: contentBoxRef,
            isOpen: isOpen,
            uuid: uuid,
            hasRowIconSlot: hasRowIconSlot,
            handleClick: handleClick,
        };
    },
    components: {
        SdsIcon: __vue_component__,
        SdsDividerLine: __vue_component__$1,
    },
});

export default script;
